import MainComponent from "components/Main";
import PropTypes from "prop-types";

import './index.less';

import SpecsList from "../specsList";
import ToggleSwitch from "components/ToggleSwitch";


/**
 * Created by viclight on 04.03.2024.
 */
export default class SpecsPanel extends MainComponent {


    static propTypes = {
        items: PropTypes.array,
        onChange: PropTypes.func
    };

    static defaultProps = {
        items: [],
        onChange: null
    };


    constructor(props) {
        super(props);

        this.state = {
            useMedGeneral: false
        };

    }

    hasMedGeneral() {
        let index = this.props.items.findIndex((it)=>{
            return it.id > 11;
        });

        if (index >= 0) {
            return true;
        }

        return false;
    }


    changeMedSpec() {

        const { useMedGeneral } = this.state;

        this.setState({ useMedGeneral: !useMedGeneral });

    }

    insertToggleSwitch(props) {
        return <ToggleSwitch {...props} />;
    }

    render() {

        //const { useMedGeneral } = this.state;

        return (
            <>
                <SpecsList items={this.props.items} isMedGeneral={false} used={true} onChange={this.props.onChange} />
            </>
        );
    }

}
